import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getEntityById } from '../../utils/DataAccessUtils';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { getContractorWO } from '../../utils/WorkOrderUtils';
import SupplierWorkOrdersDetailNotesPage from './SupplierWorkOrdersDetailNotesPage';

const SupplierWorkOrderNotesLandingPage: FC<any> = ({
	match,
	history,
	workOrdersFetching,
	workOrder,
}): React.ReactElement => {
	const contractorWO = getContractorWO(workOrder, true);

	const redirectUrl = `/supplier/workOrders/detail/${match.params.id}/contractor_notes`;

	useEffect(() => {
		!!contractorWO && history.replace(`${redirectUrl}`);
	}, [contractorWO, history, redirectUrl]);

	return workOrdersFetching ? (
		<Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: '#fff' }} spin />} />
	) : contractorWO ? null : (
		<SupplierWorkOrdersDetailNotesPage />
	);
};

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
});

export default withRouter(connect(mapStateToProps)(SupplierWorkOrderNotesLandingPage));
